/// <reference path="jquery/jquery.d.ts" />
/// <reference path="bootstrap/bootstrapselect.d.ts" />

$(document).ready(function(){
    $('.selectpicker').selectpicker();
});